export default __webpack_public_path__ + "static/O0297-cd5b57e8cd4e58cfa25d684ffac56b2d.png";